import { useState, useEffect } from 'react'
import Navbar from './components/Navbar'
import Hero from './components/Hero'
import Features from './components/Features'
import QASection from './components/QASection'
import AboutUs from './components/AboutUs'
import HowItWorks from './components/HowItWorks'
import Footer from './components/Footer'
import './style/App.css'
const Home = () =>{
    const [scrolled, setScrolled] = useState(false)

    useEffect(() => {
      const handleScroll = () => {
        const isScrolled = window.scrollY > 10
        if (isScrolled !== scrolled) {
          setScrolled(isScrolled)
        }
      }
  
      window.addEventListener('scroll', handleScroll)
      return () => {
        window.removeEventListener('scroll', handleScroll)
      }
    }, [scrolled])
    return(
        <div className="app-container">
        <Navbar scrolled={scrolled} />
        <main>
          <Hero />
          <Features />
          <HowItWorks />
          <QASection />
          <AboutUs />
        </main>
        <Footer />
      </div>
    )
}

export default Home